import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { selectFocusedRequest, isApiCallLoading } from "../../selectors";
import {
  setBreadcrumbs,
  cancelRequest,
  denyRequest,
  approveRequest,
  resolveIdentity,
  getMyRequests,
} from "../../actions";
import { RequestDetails } from "@authzsvc/common-react-components";
import { types } from "@authzsvc/api-lib";
import { useNavigate } from "react-router";

const RequestDetailsWrapper = (props) => {
  const {
    //data
    breadcrumbs,
    requestData,
    //actions
    setBreadcrumbs,
    cancelRequest,
    approveRequest,
    denyRequest,
    resolveIdentity,
    getMyRequests,
  } = props;

  const navigate = useNavigate();

  useEffect(() => {
    setBreadcrumbs(breadcrumbs);
  }, [breadcrumbs, setBreadcrumbs]);

  const [request, setRequest] = useState(requestData.request);
  const [requestor, setRequestor] = useState({});

  const getRequestor = useCallback(
    async (id) => {
      if (id) {
        let req = await resolveIdentity(id);
        setRequestor(req.payload.data);
      }
    },
    [resolveIdentity],
  );

  // Set the request data as it changes
  useEffect(() => {
    if (!request && requestData.request) {
      setRequest(requestData.request);
    }
  }, [request, requestData, getRequestor]);

  // Fetch the requestor after setting the request object
  useEffect(() => {
    const fetchOwner = async () => {
      if (request?.requestorId) {
        await getRequestor(request.requestorId);
      }
    };
    fetchOwner();
  }, [request, getRequestor]);

  const goBack = () => {
    navigate("/required-actions");
  };

  const handleAction = async (actionFn, reason) => {
    await actionFn(requestData.request.id, reason);
    await getMyRequests();

    goBack();
  };

  const handleCancel = () => {
    handleAction(cancelRequest);
  };

  const handleApprove = (reason) => {
    handleAction(approveRequest, reason);
  };

  const handleDeny = (reason) => {
    handleAction(denyRequest, reason);
  };

  return (
    <RequestDetails
      //{...props}
      loading={props.loading}
      request={
        request ? { ...request, requestorName: requestor.displayName } : null
      }
      toApprove={requestData.toApprove}
      onApprove={handleApprove}
      onCancel={handleCancel}
      onDeny={handleDeny}
    />
  );
};

RequestDetailsWrapper.propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
  requestData: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  setBreadcrumbs: PropTypes.func.isRequired,
  cancelRequest: PropTypes.func.isRequired,
  denyRequest: PropTypes.func.isRequired,
  approveRequest: PropTypes.func.isRequired,
  resolveIdentity: PropTypes.func.isRequired,
  getMyRequests: PropTypes.func.isRequired,
};

export default connect(
  (state, props) => ({
    requestData: selectFocusedRequest(state, props.id),
    loading:
      isApiCallLoading(state, types.CANCEL_REQUEST) ||
      isApiCallLoading(state, types.APPROVE_REQUEST) ||
      isApiCallLoading(state, types.DENY_REQUEST),
  }),
  {
    setBreadcrumbs,
    cancelRequest,
    denyRequest,
    approveRequest,
    resolveIdentity,
    getMyRequests,
  },
)(RequestDetailsWrapper);
